
import kpi from "./1/kpi";
import revenue from "./5/revenue";
import compared from "./compared";
import tableSwitch from "./tableSwitch";
import menu from "./menu/index";
import general from "./BI/general";
import allHotel from "./BI/allHotel";
import selectHotel from "./selectHotel";
import summary from "./charter/summary";
import applybilling from "../components/user/ApplyBilling/store";
import applyexpress from "../components/user/Logistics/store";
import applycontract from "../components/user/ApplicationContract/store";
import analysis from "./analysis";
import auth from "./auth";
import groupChannels from "./groupChannels";
import criticism from "./online/criticism";
import effectActual from "@/components/table/effect/store/actual";
import effectOcc from "@/components/table/effect/1.2/store";
import daily from "@/components/table/daily/store";
import dailyMonth from "@/components/otherHeadquartersForms/daily/1.1/store";
import monthlyAnalysis from "@/components/table//monthlyAnalysis/store";
import financePersonnel from "@/components/table/finance/personnel/store";
import kpifollow from "@/components/otherHeadquartersForms/kpifollow/store";
import salesPersonnel from "@/components/otherHeadquartersForms/salesPersonnelAssessment/store";

const stores = {
    salesPersonnel,
    financePersonnel,
    kpifollow,
    kpi,
    revenue,
    compared,
    tableSwitch,
    menu,
    general,
    allHotel,
    selectHotel,
    summary,
    applybilling,
    applyexpress,
    applycontract,
    auth,
    analysis,
    groupChannels,
    criticism,
    effectActual,
    effectOcc,
    daily,
    dailyMonth,
    monthlyAnalysis
}


export default stores;


// WEBPACK FOOTER //
// ./src/store/index.js